import { render, staticRenderFns } from "./radio-group.component.vue?vue&type=template&id=14329644&scoped=true&"
import script from "./radio-group.component.vue?vue&type=script&lang=ts&"
export * from "./radio-group.component.vue?vue&type=script&lang=ts&"
import style0 from "./radio-group.component.vue?vue&type=style&index=0&id=14329644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14329644",
  null
  
)

export default component.exports